import { TodoItem } from "@/types/todo";

export const initialTodos: TodoItem[] = [
    {
      id: "analytics-1",
      title: "Real-Time Price Charts",
      description: "Implement interactive price charts using Recharts",
      complexity: "Low",
      status: "Completed",
      category: "Analytics and Transparency Tools",
      progress: 100
    },
    {
      id: "analytics-2",
      title: "Trading Volume Analytics",
      description: "Display 24h volume and historical trading data",
      complexity: "Low",
      status: "Completed",
      category: "Analytics and Transparency Tools",
      progress: 100
    },
    {
      id: "analytics-3",
      title: "Liquidity Pool Insights",
      description: "Show detailed LP statistics and APY calculations",
      complexity: "Medium",
      status: "Completed",
      category: "Analytics and Transparency Tools",
      progress: 100
    },
    
    // Enhanced User Protection
    {
      id: "protection-1",
      title: "Dynamic Slippage Tolerance",
      description: "Auto-adjust slippage based on market volatility",
      complexity: "Medium",
      status: "Completed",
      category: "Enhanced User Protection",
      progress: 100
    },
    {
      id: "protection-2",
      title: "Volatility Circuit Breakers",
      description: "Implement trading pauses during high volatility",
      complexity: "High",
      status: "Completed",
      category: "Enhanced User Protection",
      progress: 100
    },
    {
      id: "protection-3",
      title: "Anti-Bot Measures",
      description: "Add CAPTCHA and transaction delays",
      complexity: "Medium",
      status: "Completed",
      category: "Enhanced User Protection",
      progress: 100
    },
    
    // Social and Gamification Elements
    {
      id: "social-1",
      title: "Trader Leaderboards",
      description: "Implement ranking system for active traders",
      complexity: "Low",
      status: "Completed",
      category: "Social and Gamification Elements",
      progress: 100
    },
    {
      id: "social-2",
      title: "Achievement System",
      description: "Create badges for trading milestones",
      complexity: "Low",
      status: "Completed",
      category: "Social and Gamification Elements",
      progress: 100
    },
    {
      id: "social-3",
      title: "Referral Program",
      description: "Implement user referral tracking and rewards",
      complexity: "Medium",
      status: "Completed",
      category: "Social and Gamification Elements",
      progress: 100
    },
    
    // Dynamic Token Launch Features
    {
      id: "launch-1",
      title: "Custom Bonding Curves",
      description: "Add support for multiple curve types",
      complexity: "High",
      status: "Completed",
      category: "Dynamic Token Launch Features",
      progress: 100
    },
    {
      id: "launch-2",
      title: "Fair Launch Auction",
      description: "Implement Dutch auction mechanism",
      complexity: "High",
      status: "Completed",
      category: "Dynamic Token Launch Features",
      progress: 100
    },
    {
      id: "launch-3",
      title: "Time-Based Curve Shifts",
      description: "Add support for dynamic curve parameters",
      complexity: "Medium",
      status: "Completed",
      category: "Dynamic Token Launch Features",
      progress: 100
    },

    // Advanced Governance and Community Features
    {
      id: "gov-1",
      title: "Token Governance",
      description: "Implement governance features for token holder voting",
      complexity: "High",
      status: "Not Started",
      category: "Advanced Governance and Community Features",
      progress: 0
    },
    {
      id: "gov-2",
      title: "Revenue Sharing",
      description: "Implement community revenue sharing mechanisms",
      complexity: "Medium",
      status: "Not Started",
      category: "Advanced Governance and Community Features",
      progress: 0
    },
    {
      id: "gov-3",
      title: "NFT-Backed Launches",
      description: "Enable NFT integration for token launches",
      complexity: "High",
      status: "Not Started",
      category: "Advanced Governance and Community Features",
      progress: 0
    },

    // Additional Analytics Features
    {
      id: "analytics-4",
      title: "Real-Time Analytics Dashboard",
      description: "Comprehensive dashboard with performance metrics",
      complexity: "Medium",
      status: "Not Started",
      category: "Analytics and Transparency Tools",
      progress: 0
    },
    {
      id: "analytics-5",
      title: "Advanced Audit Trails",
      description: "Detailed logs of token launch activities",
      complexity: "Medium",
      status: "Not Started",
      category: "Analytics and Transparency Tools",
      progress: 0
    },

    // Advanced Token Mechanics
    {
      id: "token-1",
      title: "Multi-Asset Bonding Curves",
      description: "Support for multiple reserve assets",
      complexity: "High",
      status: "Not Started",
      category: "Advanced Token Mechanics",
      progress: 0
    },
    {
      id: "token-2",
      title: "Dual-Token Models",
      description: "Support for utility and stable token pairs",
      complexity: "High",
      status: "Not Started",
      category: "Advanced Token Mechanics",
      progress: 0
    },
    {
      id: "token-3",
      title: "Decay Mechanisms",
      description: "Time-based token value decay implementation",
      complexity: "Medium",
      status: "Not Started",
      category: "Advanced Token Mechanics",
      progress: 0
    },

    // Additional Social Features
    {
      id: "social-4",
      title: "Creator Royalties",
      description: "Transaction fee sharing for creators",
      complexity: "Medium",
      status: "Not Started",
      category: "Social and Gamification Elements",
      progress: 0
    },
    {
      id: "social-5",
      title: "Gamified Leaderboards",
      description: "Community performance tracking system",
      complexity: "Low",
      status: "Not Started",
      category: "Social and Gamification Elements",
      progress: 0
    },
    {
      id: "social-6",
      title: "Referral Rewards",
      description: "User referral bonus system",
      complexity: "Medium",
      status: "Not Started",
      category: "Social and Gamification Elements",
      progress: 0
    },

    // Interoperability Features
    {
      id: "inter-1",
      title: "Cross-Chain Launches",
      description: "Multi-blockchain token launch support",
      complexity: "High",
      status: "Not Started",
      category: "Interoperability and Ecosystem Expansion",
      progress: 0
    },
    {
      id: "inter-2",
      title: "Interoperable NFTs",
      description: "Cross-platform NFT utility implementation",
      complexity: "High",
      status: "Not Started",
      category: "Interoperability and Ecosystem Expansion",
      progress: 0
    },
    {
      id: "inter-3",
      title: "Layer-2 Integration",
      description: "Integration with L2 scaling solutions",
      complexity: "High",
      status: "Not Started",
      category: "Interoperability and Ecosystem Expansion",
      progress: 0
    },

    // Platform Enhancements
    {
      id: "platform-1",
      title: "AI-Powered Valuation",
      description: "AI-driven analysis and predictions",
      complexity: "High",
      status: "Not Started",
      category: "Platform-Level Enhancements",
      progress: 0
    },
    {
      id: "platform-2",
      title: "Subscription Tiers",
      description: "Premium features access system",
      complexity: "Medium",
      status: "Not Started",
      category: "Platform-Level Enhancements",
      progress: 0
    },
    {
      id: "platform-3",
      title: "Native Wallet Integration",
      description: "Built-in wallet functionality",
      complexity: "High",
      status: "Not Started",
      category: "Platform-Level Enhancements",
      progress: 0
    }
];
